import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({standalone: true, name: 'productCategoryPipe'})
export class ProductCategoryPipe implements PipeTransform
{
  private translate = inject(TranslateService);

  transform(category: string): string
  {
    if (category === 'PRODUCT')
      return this.translate.instant('PRODUCT');
    else if (category === 'DARTSSCORER')
      return 'Darts Scorer';
    else if (category === 'DARTSSCORER_TOURNAMENT')
      return 'Darts Scorer (Turnier)';
    else if (category === 'DARTSSCORER_LEAGUE')
      return 'Darts Scorer (Liga)';
    else if (category === 'DARTSSCORER_SCOLIA')
      return 'Darts Scorer (Scolia)';

    return '-';
  }
}
